/**
 * Pendaftaran editor DevExtreme untuk seluruh aplikasi.
 * ---------------------------------------------------------------------------
 * MASALAH YANG DISELESAIKAN BERKAS INI
 *
 * `<Form>` DevExtreme memilih editor lewat NAMA (`editorType: 'dxTextArea'`),
 * bukan lewat komponen yang diimpor. Nama itu dicari di registry global, dan
 * sebuah widget hanya masuk registry ketika modulnya benar-benar dimuat.
 *
 * Modul Form sendiri hanya menarik LIMA editor --
 * `devextreme/ui/form/ui.form.layout_manager.js`:
 *
 *     require("../text_box");
 *     require("../number_box");
 *     require("../check_box");
 *     require("../date_box");
 *     require("../button");
 *
 * `dxTextArea`, `dxSelectBox`, dan `dxRadioGroup` TIDAK termasuk. Selama ini
 * ketiganya tetap muncul karena ada halaman lain yang kebetulan mengimpornya,
 * dan registry itu global untuk satu bundel.
 *
 * Yang membuatnya rapuh: setiap rute dimuat malas (`lazy(() => import(...))`),
 * jadi "satu bundel" tidak berarti "satu berkas". Kalau satu-satunya pengimpor
 * `text-area` berada di potongan rute LAIN yang belum pernah dibuka, maka di
 * rute yang sedang dilihat `dxTextArea` belum terdaftar -- dan DevExtreme
 * TIDAK melempar galat. Isiannya cuma tidak digambar. Kolomnya hilang tanpa
 * sepatah pesan pun, dan penyebabnya ada di berkas yang sama sekali tidak
 * dibuka.
 *
 * Mendaftarkannya di sini, dari berkas yang ikut bundel utama, membuat
 * ketiganya selalu ada di rute mana pun.
 *
 * Larik `TERDAFTAR` di bawah bukan hiasan: impor yang hanya dipakai demi efek
 * sampingnya bisa dibuang perapi modul. Menyebut tiap komponennya membuat
 * impornya terpakai, sehingga tidak mungkin ikut terbuang.
 */
import TextArea from 'devextreme-react/text-area'
import SelectBox from 'devextreme-react/select-box'
import RadioGroup from 'devextreme-react/radio-group'

export const TERDAFTAR = [TextArea, SelectBox, RadioGroup]

export default TERDAFTAR
